/**
 * GSM single-segment SMS limit (aligned with SMSWiser / backend).
 * Length uses effective GSM-7 count after merge placeholders expand.
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  SMS_GSM7_SINGLE_SEGMENT_LIMIT,
  smsEffectiveGsmLength,
} from '@trafficpulse/shared';

export const SMS_TEXT_MAX_LENGTH = SMS_GSM7_SINGLE_SEGMENT_LIMIT;

export { smsEffectiveGsmLength };

export function isSmsTextOverLimit(text: string): boolean {
  return smsEffectiveGsmLength(text) > SMS_TEXT_MAX_LENGTH;
}
